export default "__VITE_ASSET__CSz8Ehi___"